<div class="flex min-h-screen items-center justify-center bg-gray-100 px-3 dark:bg-gray-900">
  <div class="rounded-md bg-white text-center shadow-xl md:px-40 md:py-20 dark:bg-gray-800">
    <div class="flex flex-col items-center gap-4">
      <h1 class="text-9xl font-extrabold tracking-wider text-blue-600 dark:text-blue-400">404</h1>
      <p class="mt-4 mb-8 text-2xl font-semibold text-gray-800 md:text-3xl dark:text-gray-100">
        ¡Vaya! Página no encontrada.
      </p>
      <p class="mb-6 px-3 text-gray-500 dark:text-gray-300">
        Parece que intentaste acceder a una ruta que no existe.
      </p>
      <div class="flex space-x-4 p-2">
        <button matButton="elevated" color="accent" (click)="volverAtras()">
          <mat-icon role="img">arrow_back</mat-icon>
          Volver atrás
        </button>
        <button matButton="filled" routerLink="/sistema/guia-inicio">
          <mat-icon>home</mat-icon>
          Ir a Inicio
        </button>
      </div>
    </div>
  </div>
</div>
